import { useLingui } from '@lingui/react/macro';
import { parseISO } from 'date-fns';

import Stack from '@/design_system/Stack';
import InlineText from '@/design_system/Typography/InlineText';
import IconCalendar from '@/icons/Calendar.svg';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { formatDate } from '@/utils/date';

import { Item } from './Item';

export const ArticlePurchaseDate = () => {
  const { t } = useLingui();
  const { article } = useArticleContext();

  return (
    <Item label={t({ id: 'article.information.purchase-date', message: 'Purchase date' })}>
      <Stack row gap="0.25rem" alignItems="center">
        {!!article.purchaseDate && <IconCalendar />}
        <InlineText
          weight="medium"
          aria-label={t({
            id: 'article.information.purchase-date',
            message: 'Purchase date',
          })}
        >
          {article.purchaseDate
            ? formatDate(parseISO(article.purchaseDate), { dateStyle: 'medium' })
            : '-'}
        </InlineText>
      </Stack>
    </Item>
  );
};
